import { render, staticRenderFns } from "./PluginForm.vue?vue&type=template&id=18a3b178&scoped=true&"
import script from "./PluginForm.vue?vue&type=script&lang=js&"
export * from "./PluginForm.vue?vue&type=script&lang=js&"
import style0 from "./PluginForm.vue?vue&type=style&index=0&id=18a3b178&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3b178",
  null
  
)

export default component.exports